import type { IconSvgObject } from './types';

const RegisteredIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 12.5H12.5M9 12.5V7.5H12.5C13.8807 7.5 15 8.61929 15 10C15 11.3807 13.8807 12.5 12.5 12.5M9 12.5V16.5M12.5 12.5L14.5 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RegisteredIcon;
